import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "reporting" }
const _hoisted_2 = { class: "like-input" }
const _hoisted_3 = { class: "like-input" }
const _hoisted_4 = { class: "app-wrapper" }
const _hoisted_5 = { class: "section-header" }
const _hoisted_6 = { class: "first-column-with-icon-type" }
const _hoisted_7 = { class: "name-type-block ml" }
const _hoisted_8 = { class: "name-data" }
const _hoisted_9 = { class: "type-data" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = {
  key: 0,
  class: "text-status",
  style: { color: '#5A5F6F' }
}
const _hoisted_12 = {
  key: 1,
  class: "text-status",
  style: { color: '#5e4eff' }
}
const _hoisted_13 = {
  key: 2,
  class: "text-status",
  style: { color: '#5A5F6F' }
}
const _hoisted_14 = { class: "emq-table-footer" }
const _hoisted_15 = { class: "bill-summary-search" }
const _hoisted_16 = {
  key: 0,
  class: "bill-summary-data"
}
const _hoisted_17 = { class: "data-row" }
const _hoisted_18 = { class: "data-item" }
const _hoisted_19 = { class: "item-label" }
const _hoisted_20 = { class: "item-value" }
const _hoisted_21 = { class: "data-item" }
const _hoisted_22 = { class: "item-label" }
const _hoisted_23 = { class: "item-value" }
const _hoisted_24 = { class: "data-row" }
const _hoisted_25 = { class: "data-item" }
const _hoisted_26 = { class: "item-label" }
const _hoisted_27 = { class: "item-value" }
const _hoisted_28 = { class: "data-item" }
const _hoisted_29 = { class: "item-label" }
const _hoisted_30 = { class: "item-value" }
const _hoisted_31 = { class: "data-row" }
const _hoisted_32 = { class: "data-item" }
const _hoisted_33 = { class: "item-label" }
const _hoisted_34 = { class: "item-value" }
const _hoisted_35 = { class: "data-item" }
const _hoisted_36 = { class: "item-label" }
const _hoisted_37 = { class: "item-value" }
const _hoisted_38 = { class: "data-row" }
const _hoisted_39 = { class: "data-item" }
const _hoisted_40 = { class: "item-label" }
const _hoisted_41 = { class: "item-value" }
const _hoisted_42 = { class: "data-item" }
const _hoisted_43 = { class: "item-label" }
const _hoisted_44 = { class: "item-value" }

import { getReportingList, regenReporting, GetChargeBillSummary } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Download } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { StatisticsTimeGrain } from '@/types/types'
import { dateFormat, throttleBtn } from '@/common/tools'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import ReportingExport from './components/ReportingExport.vue'
import CustomerReportingExport from './components/CustomerReportingExport.vue'
import { ElMessage, ElMessageBox, ElTooltip } from 'element-plus'
import LinkOperator from '@/components/Links/LinkOperator.vue'
enum Comparator {
  After = 'gte',
  Before = 'lte',
}


import { defineComponent, ref, Ref } from 'vue'

const __default__ = defineComponent({
  name: 'Evses',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Evses')

const showCustomerDialog = ref(false)
const showDialog = ref(false)
const showInfo: Ref<undefined | Record<string, any>> = ref(undefined)
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({
  beginTimePri: Comparator.After,
  endTimePri: Comparator.Before,
})
// 添加账单概览相关变量
const showBillSummaryDialog = ref(false)
const billSearchParams = ref({
  beginTime: new Date().toISOString().slice(0, 10) + ' 00:00:00',
  endTime: new Date().toISOString().slice(0, 10) + ' 23:59:59',
})
const billSummaryData = ref<undefined | Record<string, any>>(undefined)
const lockBillSummary = ref(false)

const { getAdoType, grainOptions } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const customerExportReport = async () => {
  showCustomerDialog.value = true
  console.log('---->showCustomerDialog: ', showCustomerDialog)
}

const exportReport = async (row: any) => {
  showDialog.value = true
  showInfo.value = row
}

const regenReport = async (row: any) => {
  await ElMessageBox.confirm(t('Operation.regenConfirm'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })

  try {
    await regenReporting({ reportId: row.id })
    ElMessage.success(t(`Base.opSuccess`))
  } catch (error) {
    console.log(error)
  }
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas()
}

const handleReset = () => {
  fuzzyParams.value = {
    beginTimePri: Comparator.After,
    endTimePri: Comparator.Before,
  }
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { sn, stationID, operatorID, operatorOnly, beginTime, endTime, grain } = params
  newParams = {
    sn: sn || undefined,
    stationID: stationID || undefined,
    operatorID: operatorID || undefined,
    operatorOnly: operatorOnly || undefined,
    beginTime: beginTime || undefined,
    endTime: endTime || undefined,
    grain: grain || undefined,
  }
  return newParams
}

const loadDatas = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getReportingList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadDatas)
loadDatas()

// 格式化充电时长（秒转小时）
const formatChargingTime = (seconds: number) => {
  return (seconds / 3600).toFixed(2) + ' ' + t('Base.hour')
}

// 搜索账单概览数据
const searchBillSummary = async () => {
  if (!billSearchParams.value.beginTime || !billSearchParams.value.endTime) {
    ElMessage.warning(t('Base.pleaseInputTimeRange'))
    return
  }

  lockBillSummary.value = true
  try {
    const response = await GetChargeBillSummary({
      beginTime: billSearchParams.value.beginTime,
      endTime: billSearchParams.value.endTime,
    })
    billSummaryData.value = response
  } catch (error) {
    ElMessage.error(t('Base.opFailed'))
    console.error('Failed to get bill summary:', error)
  } finally {
    lockBillSummary.value = false
  }
}

// 关闭账单概览弹窗
const handleBillSummaryClose = () => {
  showBillSummaryDialog.value = false
  billSummaryData.value = undefined
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_scan = _resolveComponent("scan")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fuzzyParams.value.grain,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.grain) = $event)),
                  placeholder: _ctx.$t('Operation.grain'),
                  clearable: "",
                  onClear: handleSearch
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grainOptions), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectStation, {
                  modelValue: fuzzyParams.value.stationID,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.stationID) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.operatorID) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElTooltip), {
                        content: _ctx.$t('Operation.operatorOnly'),
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: fuzzyParams.value.operatorOnly,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.operatorOnly) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_el_select, {
                          modelValue: fuzzyParams.value.beginTimePri,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.beginTimePri) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('Base.gte'),
                              value: Comparator.After
                            }, null, 8, ["label", "value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_date_picker, {
                          modelValue: fuzzyParams.value.beginTime,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fuzzyParams.value.beginTime) = $event)),
                          type: "date",
                          "value-format": "YYYY-MM-DD",
                          placeholder: _ctx.$t('Base.beginTime'),
                          clearable: "",
                          onClear: handleSearch
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_select, {
                          modelValue: fuzzyParams.value.endTimePri,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((fuzzyParams.value.endTimePri) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('Base.lte'),
                              value: Comparator.Before
                            }, null, 8, ["label", "value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_date_picker, {
                          modelValue: fuzzyParams.value.endTime,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((fuzzyParams.value.endTime) = $event)),
                          type: "date",
                          "value-format": "YYYY-MM-DD",
                          placeholder: _ctx.$t('Base.endTime'),
                          clearable: "",
                          onClear: handleSearch
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    _: 1
                  }, 16)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: "",
                    icon: _unref(Search),
                    onClick: handleSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    icon: _unref(RefreshLeft),
                    onClick: handleReset
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_unref(ElTooltip), {
                    content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "icon-button",
                        plain: "",
                        icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_scan, { class: "title-warning" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Order.reportingTip')), 1)
            ]),
            _: 1
          })
        ]),
        _withDirectives((_openBlock(), _createBlock(_unref(ElTooltip), {
          content: _ctx.$t('Base.cusexportTip'),
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Download),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (customerExportReport()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.export')), 1)
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["content"])), [
          [_directive_role, 'reportingExport']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (showBillSummaryDialog.value = true))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.billSummary')), 1)
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            width: "300",
            fixed: "",
            label: _ctx.$t('Operation.reportInfo'),
            "header-align": "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_6, [
                (row.grain == _unref(StatisticsTimeGrain).STD_YEAR)
                  ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('Base.year')), 1)
                      ]),
                      _: 1
                    }))
                  : (row.grain == _unref(StatisticsTimeGrain).STD_MONTH)
                    ? (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('Base.month')), 1)
                        ]),
                        _: 1
                      }))
                    : (row.grain == _unref(StatisticsTimeGrain).STD_DAY)
                      ? (_openBlock(), _createBlock(_component_el_card, { key: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('Base.day')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_card, { key: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('Base.unknown')), 1)
                          ]),
                          _: 1
                        })),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.time), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(ElTooltip), {
                      content: row.adoName,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(row.adoName), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"]),
                    _createVNode(_component_el_tag, {
                      type: "primary",
                      effect: "plain",
                      size: "small",
                      hit: false,
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getAdoType)(row.adoType)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            width: "150",
            label: _ctx.$t('Evses.operatorName'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorId,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            width: "150",
            label: _ctx.$t('Evses.state')
          }, {
            default: _withCtx(({ row }) => [
              (row.state == 10)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(t)('Operation.reportPending')), 1))
                : (row.state == 80)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)('Operation.reportGened')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(t)('Base.unknown')), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "totalNum",
            width: "150",
            label: _ctx.$t('Operation.totalNum')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "settleElec",
            width: "150",
            label: _ctx.$t('Operation.settleElec')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "settleAmount",
            width: "150",
            label: _ctx.$t('Operation.settleAmount')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "settleElecAmount",
            width: "150",
            label: _ctx.$t('Operation.settleElecAmount')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "settleSrvAmount",
            width: "150",
            label: _ctx.$t('Operation.settleSrvAmount')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "settlDiscountAmount",
            width: "150",
            label: _ctx.$t('Operation.settlDiscountAmount')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "final",
            width: "150",
            label: _ctx.$t('Operation.final')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "settleChargingTime",
            width: "150",
            label: _ctx.$t('Operation.settleChargingTime')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString((Number(row.settleChargingTime) / 3600).toFixed(2)) + " " + _toDisplayString(_unref(t)('Base.hour')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "updatedAt",
            width: "200",
            label: _ctx.$t('Base.updatedAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.updatedAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            width: "200",
            label: _ctx.$t('Base.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            className: "table-operation",
            width: "150"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (regenReport(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Operation.regen')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'reportingRegen']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (exportReport(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.export')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'reportingExport']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[11] || (_cache[11] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ])
    ]),
    _createVNode(ReportingExport, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showDialog).value = $event)),
      info: showInfo.value
    }, null, 8, ["modelValue", "info"]),
    _createVNode(CustomerReportingExport, {
      modelValue: showCustomerDialog.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showCustomerDialog).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: showBillSummaryDialog.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showBillSummaryDialog).value = $event)),
      title: _ctx.$t('Base.billSummary'),
      width: '40%',
      "before-close": handleBillSummaryClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_form, {
            model: billSearchParams.value,
            "label-width": "80px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { gutter: 10 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('Base.beginTime')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: billSearchParams.value.beginTime,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((billSearchParams.value.beginTime) = $event)),
                            type: "datetime",
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            "default-time": '00:00:00',
                            placeholder: _ctx.$t('Base.beginTime'),
                            style: {"width":"85%"}
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('Base.endTime')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: billSearchParams.value.endTime,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((billSearchParams.value.endTime) = $event)),
                            type: "datetime",
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            "default-time": '23:59:59',
                            placeholder: _ctx.$t('Base.endTime'),
                            style: {"width":"85%"}
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    class: "search-btn-container"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            icon: _unref(Search),
                            onClick: searchBillSummary,
                            style: {"margin-top":"0","width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                            ]),
                            _: 1
                          }, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        (billSummaryData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('Operation.totalElectricity')) + ":", 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(billSummaryData.value.totalElectricity) + " kWh", 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('Operation.totalAmount')) + ":", 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(billSummaryData.value.totalAmount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('Operation.totalElecAmount')) + ":", 1),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(billSummaryData.value.totalElecAmount), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('Operation.totalServiceAmount')) + ":", 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(billSummaryData.value.totalServiceAmount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('Operation.totalDiscountAmount')) + ":", 1),
                  _createElementVNode("span", _hoisted_34, _toDisplayString(billSummaryData.value.totalDiscountAmount), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('Operation.totalFinalAmount')) + ":", 1),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(billSummaryData.value.totalFinalAmount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('Operation.totalChargeTime')) + ":", 1),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(formatChargingTime(billSummaryData.value.totalChargeTime)), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('Operation.totalOrderNum')) + ":", 1),
                  _createElementVNode("span", _hoisted_44, _toDisplayString(billSummaryData.value.totalOrderNum), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})